import React, { Component } from 'react';
import styles from './FormColumn.module.scss';

class FormColumn extends Component {
  render() {
    const { children } = this.props;

    return <div className={styles['wrapper']}>{children}</div>;
  }
}

export default FormColumn;
